import { render, staticRenderFns } from "./HongqianTabbarHome.vue?vue&type=template&id=f18df5fe&scoped=true"
import script from "./HongqianTabbarHome.vue?vue&type=script&lang=js"
export * from "./HongqianTabbarHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18df5fe",
  null
  
)

export default component.exports